import { render, staticRenderFns } from "./headerDoc.vue?vue&type=template&id=5a569eb6&scoped=true"
import script from "./headerDoc.vue?vue&type=script&lang=js"
export * from "./headerDoc.vue?vue&type=script&lang=js"
import style0 from "./headerDoc.vue?vue&type=style&index=0&id=5a569eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a569eb6",
  null
  
)

export default component.exports